import React from 'react';
import PropTypes from 'prop-types';
import {
  // withStyles,
  // Typography as TypographyBase,
  Button as ButtonBase,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import classnames from 'classnames';
import './button.css';

function getColor (color, theme, brightness = 'main') {
  if (color && theme.palette[color] && theme.palette[color][brightness]) {
    return theme.palette[color][brightness];
  }
}

function Button ({ children, color, className, style, ...props }) {
  const useStyles = makeStyles(theme => ({
    root: {
      color: getColor(color, theme),
    },
    contained: {
      backgroundColor: getColor(color, theme),
      color:
        theme.palette.type === 'dark' && !color
          ? '#000'
          : `${color ? 'white' : theme.palette.text.primary} !important`,
      '&:hover': {
        backgroundColor: getColor(color, theme, 'light'),
      },
      '&:active': {
      },
    },
    outlined: {
      color: getColor(color, theme),
      borderColor: getColor(color, theme),
    },
    select: {
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
    },
  }));
  const classes = useStyles();

  return (
    <ButtonBase
      classes={{
        contained: classes.contained,
        root: classes.root,
        outlined: classes.outlined,
      }}
      {...props}
      className={classnames(
        {
          [classes.select]: props.select,
        },
        className
      )}
      style={{ ...style }}
    >
      {children}
    </ButtonBase>
  );
}
Button.propTypes = {
  /**
   * Is this the principal call to action on the page?
   */

  color: PropTypes.string,
  onClick: PropTypes.func,
};

Button.defaultProps = {
  color: 'Primary',
  onClick: undefined,
};

export default Button;
